<script>
    import {loggedIn} from './Auth.js';
</script>

{#if $loggedIn}
    <slot name="authorized"></slot>
{:else}
    <slot name="unauthorized"></slot>
{/if}